//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalIcon from '@tidal/styles-icons/src/components/tidal-icon.vue';
import { sidebarHome, socialFacebook, socialInstagram, socialTwitter } from '@tidal/styles-icons/src/icons';

const FALLBACK_TRANSLATIONS = {
    about: 'About',
    aboutText: 'TIDAL is the first global music streaming service with high fidelity sound, hi-def video quality, along with expertly curated playlists and original content — making it a trusted source for music and culture.',
    account: 'Account',
    career: 'Careers',
    company: 'Company',
    contact: 'Contact',
    discoverTidal: 'Discover TIDAL',
    download: 'Download TIDAL',
    getStarted: 'Get Started',
    getSupport: 'Get Support',
    magazine: 'Magazine',
    manageAccount: 'Manage Account',
    partners: 'Partners',
    playlistImport: 'Playlist Import',
    press: 'Press',
    privacyPolicy: 'Privacy policy',
    redeemGiftcard: 'Redeem Giftcard',
    redeemVoucher: 'Redeem Voucher',
    signUp: 'Sign Up',
    startFreeTrial: 'Start Free Trial',
    store: 'Store',
    supportedDevices: 'Supported Devices',
    termsConditions: 'Terms and Conditions',
    accessibility: 'Accessibility Statement',
    whatIsTidal: 'What is TIDAL?',
    soundQuality: 'Sound Quality',
    pricingPlans: 'Pricing & Plans',
};

export default {
    components: {
        tidalIcon,
    },
    props: {
        baseUrl: {
            type: String,
            default: '/',
        },
        tidalUrl: {
            type: String,
            default: null,
        },
        country: {
            type: String,
            default: null,
        },
        signupUrl: {
            type: String,
            default: null,
        },
        minimal: {
            type: Boolean,
            default: false,
        },
        wrapperClass: {
            type: Boolean,
            default: true,
        },
        disableLine: {
            type: Boolean,
            default: false,
        },
        isBrazil: {
            type: Boolean,
            default: false,
        },
        disableClickableLogo: {
            type: Boolean,
            default: false,
        },
        /**
         * @property {string} [translations[].about]
         * @property {string} [translations[].aboutText]
         * @property {string} [translations[].account]
         * @property {string} [translations[].career]
         * @property {string} [translations[].company]
         * @property {string} [translations[].contact]
         * @property {string} [translations[].discoverTidal]
         * @property {string} [translations[].download]
         * @property {string} [translations[].getStarted]
         * @property {string} [translations[].getSupport]
         * @property {string} [translations[].magazine]
         * @property {string} [translations[].manageAccount]
         * @property {string} [translations[].partners]
         * @property {string} [translations[].playlistImport]
         * @property {string} [translations[].press]
         * @property {string} [translations[].privacyPolicy]
         * @property {string} [translations[].redeemGiftcard]
         * @property {string} [translations[].redeemVoucher]
         * @property {string} [translations[].signUp]
         * @property {string} [translations[].startFreeTrial]
         * @property {string} [translations[].store]
         * @property {string} [translations[].supportedDevices]
         * @property {string} [translations[].termsConditions]
         * @property {string} [translations[].accessibility]
         * @property {string} [translations[].whatIsTidal]
         * @property {string} [translations[].soundQuality]
         * @property {string} [translations[].pricingPlans]
         * @type {import('vue').PropOptions<typeof FALLBACK_TRANSLATIONS>}
         */
        translations: {
            type: Object,
            default: null,
        },
        translationFn: {
            type: Function,
            default: null,
        },
    },
    computed: {
        /** @return {string} */
        _tidalUrl() {
            return this.tidalUrl || this.baseUrl;
        },
        /** @return {string} */
        _signupUrl() {
            return this.signupUrl || (this._tidalUrl + 'try-now');
        },
        /** @return {string} */
        _country() {
            return this.country && this.country.toLowerCase();
        },
        /** @return {boolean} */
        _isBrazil() {
            return this.isBrazil || this._country === 'br';
        },
        /** @return {string} */
        deviceImage() {
            return '<svg viewBox="0 0 300 153" fill="none" class="block fullwidth padding-left-nudge padding-right-nudge margin-bottom-2"><path d="M55.5561798,83.6335178 L82.7174952,83.7716499 C85.1938121,83.7842435 87.1946103,85.7952428 87.1946103,88.2715917 L87.1946103,130.960674 L172.410017,130.960674 L172.519072,64.6597133 C172.523144,62.1838722 174.526462,60.1763765 177.00229,60.1671464 L245.567416,59.9115285 L245.567416,5 C245.567416,2.51471863 243.552697,0.5 241.067416,0.5 L60.0561798,0.5 C57.5708984,0.5 55.5561798,2.51471863 55.5561798,5 C55.5561798,13.3216841 55.5561798,13.3216841 55.5561798,21.6433682 C55.5561798,29.9650522 55.5561798,29.9650522 55.5561798,38.2867363 C55.5561798,49.2374314 55.5561798,49.2374314 55.5561798,60.5964194 C55.5561798,71.9971276 55.5561798,72.1572724 55.5561798,83.6335178 Z" stroke="#9B9B9B"></path><path d="M94.3820225,138.202247 L171.910112,138.202247" stroke="#9B9B9B" stroke-linecap="square"></path><rect stroke="#979797" x="165.668539" y="146.567416" width="133.831461" height="5.74157303" rx="2"></rect><path d="M176.910112,60.0505618 C174.424831,60.0505618 172.410112,62.0652804 172.410112,64.5505618 C172.410112,69.3544475 172.410112,69.3544475 172.410112,74.1583331 C172.410112,78.9622188 172.410112,78.9622188 172.410112,83.7661044 C172.410112,97.4891474 172.410112,97.4891474 172.410112,111.21219 L172.410112,137.696629 C172.410112,140.181911 174.424831,142.196629 176.910112,142.196629 L288.258427,142.196629 C290.743708,142.196629 292.758427,140.181911 292.758427,137.696629 L292.758427,64.5505618 C292.758427,62.0652804 290.743708,60.0505618 288.258427,60.0505618 L176.910112,60.0505618 Z" stroke="#9B9B9B"></path><path d="M42.0786517,83.6460674 C39.5933703,83.6460674 37.5786517,85.660786 37.5786517,88.1460674 C37.5786517,95.7904164 37.5786517,95.7904164 37.5786517,103.434765 C37.5786517,114.93245 37.5786517,114.93245 37.5786517,126.430135 L37.5786517,147.808989 C37.5786517,150.29427 39.5933703,152.308989 42.0786517,152.308989 L82.6404494,152.308989 C85.1257308,152.308989 87.1404494,150.29427 87.1404494,147.808989 L87.1404494,88.1460674 C87.1404494,85.660786 85.1257308,83.6460674 82.6404494,83.6460674 L42.0786517,83.6460674 Z" stroke="#9B9B9B"></path><path d="M5,100.5 C2.51471863,100.5 0.5,102.514719 0.5,105 C0.5,110.190071 0.5,110.190071 0.5,115.380142 C0.5,119.738135 0.5,119.738135 0.5,124.096129 C0.5,128.454122 0.5,128.454122 0.5,132.812115 L0.5,147.808989 C0.5,150.29427 2.51471863,152.308989 5,152.308989 L21.9662921,152.308989 C24.4515735,152.308989 26.4662921,150.29427 26.4662921,147.808989 L26.4662921,105 C26.4662921,102.514719 24.4515735,100.5 21.9662921,100.5 L5,100.5 Z" stroke="#9B9B9B"></path></svg>';
        },
        /** @return {number} */
        currentYear() {
            const today = new Date();
            return today.getFullYear();
        },
        /** @return {Record<'sidebarHome' | 'socialFacebook' | 'socialInstagram' | 'socialTwitter' , string>} */
        icons() {
            return {
                sidebarHome,
                socialFacebook,
                socialInstagram,
                socialTwitter,
            };
        },
        fallbackTranslations() {
            return FALLBACK_TRANSLATIONS;
        },
    },
    methods: {
        /**
         * @param {keyof FALLBACK_TRANSLATIONS} translationKey
         * @return {string}
         */
        getTranslation(translationKey) {
            let translation;

            if (this.translationFn) {
                translation = this.translationFn(translationKey);
            }

            if (!translation && this.translations) {
                translation = this.translations[translationKey];
            }

            const isTranslated = translation && translation !== `webCommon.footer.${translationKey}`;
            return isTranslated ? translation : this.fallbackTranslations[translationKey];
        },
    },
};
